import {createSelector} from 'reselect'

export const getShowFilterModal = createSelector(
  state => state && state.vehicleParts && state.vehicleParts.list && state.vehicleParts.list.showFilterModal,
  showFilterModal => showFilterModal
)
